import { Fancybox } from "@fancyapps/ui";
let Flickity = require('flickity');


let lastWindowWidth = window.innerWidth;
let breakPoint = 768;
let flktyInstance = null;
let flktyConfig = {
    adaptiveHeight: true,
    initialIndex: 0,
    prevNextButtons: true,
    wrapAround: true,
    contain: true,
    pageDots: false,
    cellAlign: 'center',
    lazyLoad: 10,
    arrowShape: 'M0,40.1403473 C0,41.153967 0.409486627,42.0511914 1.22845988,42.8320207 L37.4764405,79.1456314 C38.2578307,79.9023402 39.1362637,80.2806947 40.1117394,80.2806947 C41.1236762,80.2806947 41.9713976,79.9455327 42.6549037,79.2752087 C43.3384098,78.6048847 43.6801629,77.7749731 43.6801629,76.7854739 C43.6801629,76.2980165 43.5946195,75.8258448 43.4235326,75.3689587 C43.2524457,74.9120726 43.0081561,74.5248833 42.6906637,74.207391 L26.4892973,57.8756058 L8.14990576,40.8269386 L7.27315563,42.9742192 L23.1371163,43.7289647 L96.4484047,43.7289647 C97.4867057,43.7289647 98.3382135,43.3932418 99.0029281,42.7217959 C99.6676427,42.05035 100,41.1898672 100,40.1403473 C100,39.0908275 99.6676427,38.2303446 99.0029281,37.5588988 C98.3382135,36.8874529 97.4867057,36.5517299 96.4484047,36.5517299 L23.1371163,36.5517299 L7.27315563,37.3064755 L8.14990576,39.4907781 L26.4892973,22.4050889 L42.6906637,6.07330372 C43.0193749,5.73281278 43.2664692,5.3398739 43.4319467,4.89448708 C43.5974242,4.44910025 43.6801629,3.98267815 43.6801629,3.49522079 C43.6801629,2.50572159 43.3384098,1.67581 42.6549037,1.005486 C41.9713976,0.335162 41.1236762,0 40.1117394,0 C39.6125022,0 39.1289715,0.103072833 38.661147,0.309218498 C38.1933226,0.515364163 37.7061457,0.877311075 37.1996163,1.39505924 L1.22845988,37.4486739 C0.409486627,38.2182844 0,39.1155089 0,40.1403473 Z',
    on: {
        ready: function() {
            // console.log('Flickity is ready', this);
            let t = this;
            t.resize();

            window.setTimeout(function(){
                t.resize();
            }, 400)
        },
        settle: function() {
            // console.log('Flickity is settle', this);
            this.resize();
        },
        change: function( index ) {
            // console.log( 'Slide changed to' + index );
        }
    }
};

if(!flktyInstance){
   carouselInit();
}


function isMobile(){
    return (lastWindowWidth <  breakPoint) ? true : false;
}


function carouselInit(){
    flktyInstance = new Flickity( '.carousel', flktyConfig);
}

window.addEventListener('resize', function() {
    lastWindowWidth = window.innerWidth;

    carouselInit();

    // if( isMobile() ){
    // }
    // else{
    //     if(flktyInstance) {
    //         flktyInstance.destroy();
    //     }
    // }

});



Fancybox.Plugins.Toolbar.defaults.items.close = {
    type: "button",
    class: "fancybox__button--close w-10 h-10 shadow-none drop-shadow-none text-black bg-white hover:text-white hover:bg-black hover:outline hover:outline-white hover:outline-3 hover:shadow-none focus:outline focus:outline-white focus:outline-3 focus:shadow-none",
    label: "Close Modal",
    html: `<svg xmlns="http://www.w3.org/2000/svg" viewbox="0 0 22.75 22.654" class="stroke-current shadow-none drop-shadow-none">
        <title>Close Button</title>
        <g fill="none" stroke-width="2">
            <path d="M.708.707l21.24 21.24"/>
            <path d="M.803 21.947L22.043.707"/>
        </g>
    </svg>`,
    click: function (event) {
      event.preventDefault();

      this.fancybox.close();
    },
};


Fancybox.bind("[data-fancybox]", {
    Toolbar: {
        display: [
            "close",
        ]
    },
    Image: {
        zoom: false,
    },
    Carousel: {
        Navigation: {
            prevTpl:
                `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 33 33" class="w-full h-full stroke-1">
                    <title>Previous Button</title>
                    <g>
                        <g transform="rotate(180 16.5 16.5)" class="fill-white stroke-black group-hover:fill-black group-hover:stroke-white group-focus:fill-black group-focus:stroke-white">
                            <circle cx="16.5" cy="16.5" r="16.5" stroke="none"/>
                            <circle cx="16.5" cy="16.5" r="15.5" fill="none"/>
                        </g>
                        <g class="stroke-black group-hover:stroke-white group-focus:stroke-white">
                            <path fill="none" stroke-width="2" d="M18.063 11.524 13 16.418l5.063 5.06" />
                        </g>
                    </g>
                </svg>`,
            nextTpl:
                `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 33 33" class="w-full h-full stroke-1">
                    <title>Next Button</title>
                    <g class="fill-white stroke-black group-hover:fill-black group-hover:stroke-white group-focus:fill-black group-focus:stroke-white">
                        <circle cx="16.5" cy="16.5" r="16.5" stroke="none"/>
                        <circle cx="16.5" cy="16.5" r="15.5" fill="none"/>
                    </g>
                    <g class="stroke-black group-hover:stroke-white group-focus:stroke-white">
                        <path fill="none" stroke-width="2" d="M14.937 21.476 20 16.582l-5.063-5.06" />
                    </g>
                </svg>`,
            classNames:{
                next: 'is-next group w-12 h-12 focus:shadow-none',
                prev: 'is-prev group w-12 h-12 focus:shadow-none',
            }
        }
    },
    on:{
        "done": (fancybox, slide) => {
            // console.log(`done!`, slide);
        },
        "load": (fancybox, slide) => {
            let captions = document.querySelector('.fancybox__caption');
            if(captions) captions.style.width = slide.$image.offsetWidth + 'px';
        }
    }
});